
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getAddPermissionDtoFormGroup() {
return new FormGroup({
    permissionId: new FormControl<number | undefined>(undefined, [Validators.required]),
})
;
}
      